(function () {
    "use strict";

    angular
        .module("app")
        .service("receivesService", service);

    function service($http, $q) {
        const self = this;

        self.searchPending = () => {
            return $http.post(`/api/receives/search-pending`).then(res => res.data);
        }

        self.searchHistorical = (from, to) => {
            const req = {
                from,
                to
            };
            return $http.post(`/api/receives/search-historical`, req).then(res => res.data);
        }

        self.create = req => {
            //const req = {
            //    receive_date, 
            //    order_id,
            //    item_id,
            //    quantity_received,
            //    quantity_UOM,
            //    lot_no,
            //    notes 
            //};
            return $http.post(`/api/receives`, req).then(res => res.data);
        }

        self.cancel = order_receive_id => {
            const req = {
                order_receive_id
            };
            return $http.post(`/api/receives/cancel`, req).then(res => res.data);
        }

        self.uncancel = order_receive_id => {
            const req = {
                order_receive_id
            };
            return $http.post(`/api/receives/uncancel`, req).then(res => res.data);
        }
    }
    service.$inject = ["$http", "$q"];

})()